
























































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { SaleService } from "@/services/api/app/erp/sales/SaleService";
import { DiscountAuditReport, filterAudit, csvCell } from "@/services/api/app/erp/sales/DiscountAudit";

function localDate(d: Date): string { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
@Component
export default class DiscountAudit extends Vue {
  from = localDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  to = localDate(new Date());
  status = "all";
  search = "";
  report: DiscountAuditReport | null = null;
  loading = false;
  error = "";
  copied = false;
  page = 1;
  pageSize = 25;
  private generation = 0;
  private ready = false;
  private initialWorkspace = true;
  get workspaceId(): string { return this.$store.state.tenant.currentWorkspace ? this.$store.state.tenant.currentWorkspace.id : ""; }
  get workspaceName(): string { return this.$store.state.tenant.currentWorkspace ? this.$store.state.tenant.currentWorkspace.name : "Selecciona una sucursal"; }
  get filtered() { return filterAudit(this.report ? this.report.invoices : [], this.status, this.search); }
  get paged() { return this.filtered.slice((this.page - 1) * this.pageSize, this.page * this.pageSize); }
  get pages() { return Math.ceil(this.filtered.length / this.pageSize); }
  get withCount() { return this.report ? this.report.invoices.filter(i => i.hasAuthorization).length : 0; }
  mounted() {
    const q = this.$route.query;
    if (typeof q.from === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(q.from)) this.from = q.from;
    if (typeof q.to === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(q.to)) this.to = q.to;
    if (q.status === 'with' || q.status === 'without') this.status = q.status;
    if (typeof q.q === 'string') this.search = q.q;
    this.ready = true;
    this.initializeWorkspace();
  }
  @Watch('$store.state.tenant.workspaces') workspacesChanged() { if (this.ready) this.initializeWorkspace(); }
  @Watch('workspaceId') workspaceChanged() { if (this.ready) { if (this.initialWorkspace) this.initializeWorkspace(); else this.load(); } }
  initializeWorkspace() {
    if (!this.initialWorkspace) return;
    const requested = this.$route.query.sucursal;
    const list = this.$store.state.tenant.workspaces || [];
    if (requested) {
      if (!list.length) return;
      const workspace = list.find(w => w.id === requested);
      if (!workspace) { this.initialWorkspace = false; this.report = null; this.error = 'La sucursal del enlace no está disponible en tu sesión. Selecciona una sucursal autorizada.'; return; }
      if (workspace.id !== this.workspaceId) { this.$store.commit('tenant/currentWorkspace', workspace); return; }
    }
    if (this.workspaceId) { this.initialWorkspace = false; this.load(); }
  }
  async load() {
    const seq = ++this.generation;
    this.report = null; this.error = ''; this.page = 1;
    if (!this.workspaceId) return;
    this.loading = true;
    this.updateUrl();
    try { const data = await new SaleService().getDiscountAudit(this.from, this.to); if (seq === this.generation) this.report = data; }
    catch (e) { if (seq === this.generation) this.error = String(e); }
    finally { if (seq === this.generation) this.loading = false; }
  }
  updateUrl() {
    const query = { from: this.report ? this.report.from.slice(0, 10) : this.from, to: this.report ? this.report.to.slice(0, 10) : this.to, status: this.status, sucursal: this.workspaceId, ...(this.search ? { q: this.search } : {}) };
    if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) this.$router.replace({ name: 'erp.sales.discountAudit', query }).catch(() => undefined);
    this.copied = false;
  }
  setStatus(status: string) { this.status = status; this.updateFilters(); }
  updateFilters() { this.page = 1; this.updateUrl(); }
  async share() { try { await navigator.clipboard.writeText(window.location.href); this.copied = true; } catch (_) { this.error = 'Copia el enlace de la barra de direcciones.'; } }
  number(value: number): string { return value.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  date(value: string | null): string { if (!value) return ''; const p = value.slice(0, 10).split('-'); return p.reverse().join('/'); }
  timestamp(value: string): string { return new Date(value).toLocaleString('es-MX'); }
  download() {
    if (!this.report) return;
    const head = ['Sucursal', 'Desde', 'Hasta', 'Factura', 'Fecha', 'Cliente', 'Usuario', 'Kilos factura', 'Autorización registrada', 'Criterio por grupo', 'Evidencia por grupo'];
    const rows = this.filtered.map(r => [this.report!.branchName, this.report!.from.slice(0, 10), this.report!.to.slice(0, 10), r.type + '-' + r.folio, r.date.slice(0, 10), r.customer, r.user, r.totalKilos, r.hasAuthorization ? 'CON' : 'SIN registro completo', r.groups.map(g => g.discount + '% / ' + g.kilos + ' kg / máximo ' + g.allowed + '%').join('; '), r.groups.map(g => g.evidence + (g.quoteFolio ? ' PR-' + g.quoteFolio : '')).join('; ')]);
    const csv = '\uFEFF' + [head, ...rows].map(row => row.map(csvCell).join(',')).join('\r\n');
    const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
    const link = document.createElement('a'); link.href = url; link.download = 'auditoria-descuentos-' + this.report.from.slice(0, 10) + '-' + this.report.to.slice(0, 10) + '.csv'; link.click(); URL.revokeObjectURL(url);
  }
}
